import { render, staticRenderFns } from "./shareOpportunity.vue?vue&type=template&id=1288b093"
import script from "./shareOpportunity.vue?vue&type=script&lang=js"
export * from "./shareOpportunity.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports